import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  getAccessToken,
  refreshAccessToken,
} from "../api";

export default function Upgrade() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    async function routeUser() {
      let token = getAccessToken();

      if (!token) {
        try {
          token = await refreshAccessToken();
        } catch {
          token = null;
        }
      }

      if (cancelled) return;

      if (token) {
        navigate("/plans", {
          replace: true,
        });
      } else {
        navigate(
          "/login?redirect=/plans",
          { replace: true }
        );
      }
    }

    routeUser();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-zinc-950 text-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center">
        <h1 className="text-3xl font-bold mb-3">
          Opening SatStacker…
        </h1>

        <p className="text-zinc-300">
          Taking you to Smart Timing.
        </p>
      </div>
    </div>
  );
}